import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const LOCALES = {
  zh: 'zh-CN',
  en: 'en-US',
}

export function normalizeLocale(value) {
  const locale = (value || '').toString().trim().toLowerCase()
  if (!locale) return null
  if (locale === 'en' || locale === 'en-us' || locale === 'english') return LOCALES.en
  if (locale === 'zh' || locale === 'zh-cn' || locale === 'chinese') return LOCALES.zh
  return null
}

export function resolveLocaleFromRoute(route) {
  const query = route && route.query ? route.query : {}
  const fromQuery = normalizeLocale(query.lang || query.locale || query.language)
  if (fromQuery) return fromQuery

  if (route && typeof route.path === 'string' && route.path.endsWith('_en')) {
    return LOCALES.en
  }

  if (route && route.meta && route.meta.defaultLocale) {
    return normalizeLocale(route.meta.defaultLocale) || LOCALES.zh
  }

  return LOCALES.zh
}

const messages = {
  'zh-CN': {
    common: {
      langSwitch: '切换语言',
      closePage: '关闭页面',
    },
    index: {
      fileCount: '文件数',
      prev: '上一个',
      next: '下一个',
      agree: '已阅读并同意协议内容',
      signNow: '立即签署',
      loadingToast: '1.请阅读文件后，进行协议签署；<br>2.请签署法人英文名字（或名字拼音）；<br><br>正在获取签署文件，请耐心等待...',
      loadSuccess: '获取签署文件成功',
      noPending: '该订单没有待签署文件，请联系客服',
    },
    signature: {
      signArea: '签字区：',
      clear: '清除',
      submit: '提交（签署法人中文拼音名字）',
      success: '签署完成',
      confirmTitle: '提示',
      confirmText: '确认提交签署吗？',
      confirmClose: '取消',
      confirmOk: '确认',
      hintTitle: '提示',
      hintText: '签署内容不能为空',
      hintOk: '确定',
    },
  },
  'en-US': {
    common: {
      langSwitch: 'Switch language',
      closePage: 'Close page',
    },
    index: {
      fileCount: 'Number of files',
      prev: 'Last',
      next: 'Next',
      agree: 'Have read and agreed to the agreement',
      signNow: 'Sign immediately',
      loadingToast: '1.Please read the document before signing the agreement;<br>2.Please sign the legal representative name in English;<br><br>Getting signed documents, please be patient...',
      loadSuccess: 'Signed files loaded successfully',
      noPending: 'There are no pending documents for this order. Please contact customer service.',
    },
    signature: {
      signArea: 'Signature Area:',
      clear: 'Clear',
      submit: 'Submit (Legal Representative Name in English)',
      success: 'Signature successful, please wait for review.',
      confirmTitle: 'Hint',
      confirmText: 'Confirm submission for signature?',
      confirmClose: 'Close',
      confirmOk: 'Confirm',
      hintTitle: 'Hint',
      hintText: 'Signature content cannot be empty',
      hintOk: 'OK',
    },
  },
}

const i18n = new VueI18n({
  locale: LOCALES.zh,
  fallbackLocale: LOCALES.zh,
  messages,
})

export default i18n
